export default __webpack_public_path__ + "static/media/toolbar-logo.e4bf9a2f.png";